import { AttributeValue } from "../../../dom-tools/AttributeValue";
import { SortText } from "../../../text/SortText";
import { DateParser } from "../../../date/DateParser";
import { Sorter } from "./Sorter";

export class TextSorter extends Sorter
{
  static readonly type = new AttributeValue( Sorter.sorterType, "text" );

  _sortElements( elements:Element[] )
  {
    let getTextValue = ( e:Element )=>
    {
      let sourceElement = e.querySelector( this.selector ); 

      if ( sourceElement == null )
      {
        console.warn( "No source element found:", e );
      } 

      return sourceElement.textContent.toLowerCase();
    }

    SortText.sort( elements, ( e ) => { return getTextValue( e ) } );
  }

}